"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Log = function Log(_ref) {
  var message = _ref.message,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "error" : _ref$type;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;

  if (type === "warning") {
    type = "warn";
  }

  (0, _react.useEffect)(function () {
    if (!message) return;
    var typeEnum = null;

    switch (type) {
      case "info":
        typeEnum = 1;
        break;

      case "warning":
      case "warn":
        typeEnum = 2;
        break;

      case "error":
      default:
        typeEnum = 3;
        break;
    }

    console[type](message);

    _axios.default.get("".concat(REACT_APP_PATH, "/log.api?type=").concat(typeEnum, "&message=").concat(message)); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [message, type]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = Log;
exports.default = _default;